module.exports = __webpack_public_path__ + "img/lang_ja.c8210f1a.svg";